import { useState } from "react";
import "../../styles/ServicesSlider.css";
import Projector from "../../icons/Projector.tsx";
import Idea from "../../icons/Idea.tsx";
import Laptop from "../../icons/Laptop.tsx";
import Consulting from "../../icons/Consulting.tsx";

const cards = [
  {
    title: "Build from Scratch",
    copy: "We architect and deliver full systems across 13 industries. Java/React, microservices, event-driven, secure by design.",
    bullets: [
      "Java, React, .NET, Python",
      "Microservices & event-driven",
      "API-first (REST/GraphQL)",
    ],
  },
  {
    title: "Consulting & Missions",
    copy: "Senior experts embedded in your teams: architects, engineers, DevOps, security, PMs.",
    bullets: [
      "Solution / Integration Architects",
      "Cloud & DevOps engineers",
      "Security & IAM specialists",
    ],
  },
  {
    title: "Training & Formations",
    copy: "Hands-on training for Cloud, Software, Data/AI, Security & Agile/DevOps—workshops, bootcamps, on-site or online.",
    bullets: [
      "Cloud & DevOps",
      "Software & APIs",
      "Data & AI, Security, Agile",
    ],
  },
  {
    title: "R&D / Innovation",
    copy: "AI automation, IoT & edge, NLP/data mining, next-gen security. From PoC to Pilot to Scale.",
    bullets: ["PoC → Pilot → Scale", "AI, IoT, NLP", "Security innovations"],
  },
];

export default function ServicesSlider() {
  const [active, setActive] = useState(0);

  return (
    <section className="services-wrapper">
      {/* Section Title */}
      <h2 className="services-title">Services</h2>

      <div className="services-layout">
        {/* LEFT: Custom SVG Diagram */}
        <svg
          viewBox="0 0 500 500"
          className="circle-diagram"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Segments */}
          <path
            d="M 193.2 416.8 l 45.5 -63.5 c -44.3 -6.1 -79.4 -40.8 -86.2 -84.9 L 75.1 213 c -0.5 -0.3 -0.9 -0.4 -1.2 -0.4 c -0.1 0 -0.3 0.1 -0.7 0.3 L 0 264.4 c 5.8 128.3 107.3 231.7 234.8 240.7 L 193 445.6 l -0.1 -0.2 c -2.8 -4.4 -4.2 -9 -4.2 -13.8 c 0 -5 1.4 -9.9 4.2 -14.2 L 193.2 416.8 Z"
            className={`segment-path ${active === 0 ? "is-active" : ""}`}
            onMouseEnter={() => setActive(0)}
            onClick={() => setActive(0)}
          />
          <path
            d="M 292.9 73.8 c 0 0 0 -0.2 -0.3 -0.6 L 241 0 C 112.7 5.8 9.3 107.3 0.4 234.8 l 59.5 -41.9 l 0.2 -0.1 c 4.4 -2.8 9 -4.2 13.8 -4.2 c 5 0 9.9 1.4 14.2 4.2 l 0.6 0.4 l 63.5 45.5 c 6.1 -44.3 40.9 -79.4 84.9 -86.2 l 55.4 -77.3 c 0.3 -0.5 0.4 -0.9 0.4 -1.2 C 292.9 73.8 292.9 73.8 292.9 73.8"
            className={`segment-path ${active === 1 ? "is-active" : ""}`}
            onMouseEnter={() => setActive(1)}
            onClick={() => setActive(1)}
          />
          <path
            d="M 270.6 0.4 l 41.9 59.5 l 0.1 0.2 c 2.8 4.4 4.2 9 4.2 13.9 c 0 5 -1.4 9.9 -4.2 14.2 l -0.4 0.6 l -45.5 63.5 c 44.3 6.1 79.4 40.8 86.2 84.9 l 77.3 55.4 c 0.5 0.3 0.9 0.4 1.2 0.4 c 0.1 0 0.1 0 0.1 0 s 0.2 0 0.6 -0.3 l 73.2 -51.5 C 499.6 112.7 398.2 9.3 270.6 0.4"
            className={`segment-path ${active === 2 ? "is-active" : ""}`}
            onMouseEnter={() => setActive(2)}
            onClick={() => setActive(2)}
          />
          <path
            d="M 445.4 312.6 c -4.4 2.8 -9 4.2 -13.9 4.2 c -5 0 -9.9 -1.4 -14.2 -4.2 l -0.6 -0.4 l -63.5 -45.5 c -6.1 44.3 -40.8 79.4 -84.9 86.2 L 213 430.4 c -0.3 0.5 -0.4 0.9 -0.4 1.2 c 0 0.1 0 0.1 0 0.1 s 0 0.2 0.3 0.6 l 51.5 73.2 c 128.3 -5.8 231.7 -107.3 240.7 -234.8 l -59.5 41.9 H 445.4 Z"
            className={`segment-path ${active === 3 ? "is-active" : ""}`}
            onMouseEnter={() => setActive(3)}
            onClick={() => setActive(3)}
          />

          {/* Icons above each segment */}
          {/* Icons above each segment */}
          <foreignObject x="80" y="320" width="65" height="65">
            <div
              onClick={() => setActive(0)}
              onMouseEnter={() => setActive(0)}
              style={{ cursor: "pointer" }}
            >
              <Laptop className={active === 0 ? "is-active" : ""} />
            </div>
          </foreignObject>

          <foreignObject x="110" y="90" width="65" height="65">
            <div
              onClick={() => setActive(1)}
              onMouseEnter={() => setActive(1)}
              style={{ cursor: "pointer" }}
            >
              <Consulting className={active === 1 ? "is-active" : ""} />
            </div>
          </foreignObject>

          <foreignObject x="350" y="120" width="65" height="65">
            <div
              onClick={() => setActive(2)}
              onMouseEnter={() => setActive(2)}
              style={{ cursor: "pointer" }}
            >
              <Projector className={active === 2 ? "is-active" : ""} />
            </div>
          </foreignObject>

          <foreignObject x="320" y="350" width="65" height="65">
            <div
              onClick={() => setActive(3)}
              onMouseEnter={() => setActive(3)}
              style={{ cursor: "pointer" }}
            >
              <Idea className={active === 3 ? "is-active" : ""} />
            </div>
          </foreignObject>

          {/* Center circle + label */}
          <circle cx="250" cy="250" r="45" className="circle-center" />
          <text x="250" y="255" textAnchor="middle" className="circle-label">
            JaveLynx
          </text>
        </svg>

        {/* RIGHT: Details Card */}
        <div className="details-card">
          <h3>{cards[active].title}</h3>
          <p>{cards[active].copy}</p>
          <ul>
            {cards[active].bullets.map((b, j) => (
              <li key={j}>{b}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
